import { memo } from "react"
import { RouteStop } from "@/reducers/routes2gSlice"
import ActionMarker, { ActionType } from "./ActionMarker"
import DriverLocationMarker from "./DriverLocationMarker"

export type SingleStopMarkerProps = {
  stop: RouteStop
}

/**
 * Renders a marker for a single stop when no route is available yet.
 * Shows DriverLocationMarker for driver locations, ActionMarker for other stops.
 */
const SingleStopMarker = memo(({ stop }: SingleStopMarkerProps) => {
  const lat = stop.location?.lat
  const lon = stop.location?.lon

  // Try to parse coordinates from formattedAddress if lat/lon not available
  let latitude: number | undefined =
    typeof lat === "string" ? parseFloat(lat) : lat
  let longitude: number | undefined =
    typeof lon === "string" ? parseFloat(lon) : lon

  if ((!latitude || !longitude) && stop.location?.formattedAddress) {
    const coords = stop.location.formattedAddress.split(",")
    if (coords.length === 2) {
      const parsedLat = parseFloat(coords[0])
      const parsedLon = parseFloat(coords[1])
      if (!isNaN(parsedLat) && !isNaN(parsedLon)) {
        latitude = parsedLat
        longitude = parsedLon
      }
    }
  }

  if (!latitude || !longitude || isNaN(latitude) || isNaN(longitude)) {
    return null
  }

  // Show animated driver location marker for driver stops
  if (stop.action === "from_driver_location") {
    return (
      <DriverLocationMarker
        longitude={longitude}
        latitude={latitude}
        initials={stop.driverInitials}
      />
    )
  }

  // Show action marker for other stops
  const action = (stop.action as ActionType) || "other"

  return (
    <ActionMarker longitude={longitude} latitude={latitude} action={action} />
  )
})

export default SingleStopMarker
